import script from "./PairPriceGraph.vue?vue&type=script&setup=true&lang=ts"
export * from "./PairPriceGraph.vue?vue&type=script&setup=true&lang=ts"

import "./PairPriceGraph.vue?vue&type=style&index=0&id=b7886c1c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7886c1c"]])

export default __exports__